import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes',
)({
  component: () => <Outlet />,
})
